import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import {
    KYC_STATE_DECLINED,
    KYC_STATE_RETRY,
    KYC_STATE_VALIDATED,
    KYC_USE_CASE_DECLINED_PURCHASE,
    KYC_USE_CASE_FAILURE_BANK_TRANSFER
} from '../../../../services/kyc/constants';
import { PATH } from '../../../../constants/path';
import { DECLINED_PAYMENT_CODE } from '../../../../services/checkout/constants';

import { resetKyc } from '../../../../services/kyc/actions';
import { fetchIsIdentityVerified } from '../../../../services/account/identity/actions';

import { getMerchantCardUrl } from '../../../../services/partner/utils';

const ErrorEbonPageStateController = ({
    status,
    partner,
    failureBankTransferEnabled,
    kycErrorCase,
    setKycErrorCase,
    history,
    kycState,
    identityVerified,
    fetchIsIdentityVerified,
    resetKyc
}) => {
    /* Fetch identity verification state on display */
    useEffect(() => {
        fetchIsIdentityVerified();
    }, []);

    /* Determine the KYC use case */
    useEffect(() => {
        if (!kycErrorCase && !identityVerified) {
            if (failureBankTransferEnabled) {
                setKycErrorCase(KYC_USE_CASE_FAILURE_BANK_TRANSFER);
            } else if (status === DECLINED_PAYMENT_CODE) {
                setKycErrorCase(KYC_USE_CASE_DECLINED_PURCHASE);
            }
        }
    });

    const redirectToMerchantCard = () => {
        if (partner && partner.id) {
            const urlFicheMarchand = getMerchantCardUrl(partner, false, true);
            history.push(urlFicheMarchand);
        } else {
            history.push(PATH.HOME_PATH);
        }
    };

    /* Handle KYC states */
    useEffect(() => {
        if (kycState === KYC_STATE_VALIDATED) {
            fetchIsIdentityVerified();
            if (kycErrorCase === KYC_USE_CASE_DECLINED_PURCHASE) {
                resetKyc();
                redirectToMerchantCard();
            }
        }
        if (kycState === KYC_STATE_DECLINED || kycState === KYC_STATE_RETRY) {
            if (kycErrorCase === KYC_USE_CASE_FAILURE_BANK_TRANSFER) {
                resetKyc();
                redirectToMerchantCard();
            }
        }
    }, [kycState]);

    return null;
};

ErrorEbonPageStateController.propTypes = {
    status: PropTypes.string,
    partner: PropTypes.object,
    failureBankTransferEnabled: PropTypes.bool,
    kycErrorCase: PropTypes.string,
    setKycErrorCase: PropTypes.func
};

const mapStateToProps = state => {
    return {
        kycState: state.kyc.state,
        identityVerified: state.account.identity.verified
    };
};

const mapDispatchToProps = {
    fetchIsIdentityVerified,
    resetKyc
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ErrorEbonPageStateController)
);



// WEBPACK FOOTER //
// ./src/components/pages/ebon/erreur/ErrorEbonPageStateController.js